<template>
  <div>
    <div
      v-if="activeStatus === '0'"
      class="check_box"
      :style="{ background: `url(${dakaInfo.activityBackgroundPicture})` }"
    >
      <div class="check_time" v-if="endTime && !toolActiveStatus(true)">
        <div>活动倒计时：</div>
        <CommonTimer :endTime="endTime" />
        <!-- <div class="check_item_hour_num"></div> -->
        <!-- 天 -->
      </div>
      <div class="check_main_image">
        <img :src="dakaInfo.activityPicture" alt />
      </div>
      <div class="check_main_content">
        <!-- 未开始状态 -->
        <!-- 未参与-活动说明 -->
        <div v-if="dakaInfo.continuousMaxDakaNumber === 0 || !userInfo.id" class="detail piece_pub">
          <div class="content_top">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_desc.png"
              alt
            />
          </div>

          <div class="pub_content">
            <div class="dc_check">
              <img
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/check.png?v=1"
                alt
              />
              <span>{{ dakaInfo.activityName }}</span>
            </div>
            <div class="join_num">
              <img
                class="join_num_icon"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_people_icon.png"
                alt
              />
              参与人数：
              <span>{{ dakaInfo.joinShowNumber }}</span>人已经参加
            </div>
            <div class="join_num active_time">
              <img
                class="join_num_icon"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_time_icon.png"
                alt
              />
              活动时间：{{ dakaInfo.startTime }} - {{ dakaInfo.endTime }}
            </div>
          </div>
        </div>

        <!-- 打卡日历 -->
        <div class="calendar_box">
          <div class="calendar_title">
            <img
              :class="['img', calendarIndex == 0 ? 'img_hidden' : '']"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/calendar_left.png"
              alt
              @click="onChangeYear(false)"
            />
            <div class="year">{{currTimeStr}}</div>
            <img
              :class="['img', calendarIndex == calendarDateRange.length - 1 ? 'img_hidden' : '']"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/calendar_right.png"
              alt
              @click="onChangeYear(true)"
            />
          </div>
          <div class="calendar_content">
            <swiper ref="mySwiper" @slideChange="slideChange">
              <swiper-slide :key="index" v-for="(item,index) in calendarDateRange">
                <div class="video-player" style="position: relative">
                  <van-calendar
                    :poppable="false"
                    :show-title="false"
                    :show-subtitle="false"
                    :show-mark="false"
                    :min-date="new Date(item[0])"
                    :max-date="new Date(item[1])"
                    :first-day-of-week="1"
                    :formatter="formatter"
                    @select="onCalenderSelect"
                  ></van-calendar>
                </div>
              </swiper-slide>
            </swiper>

            <div class="calendar_tip_box">
              <div class="calendar_tip_item">
                <img
                  class="calendar_tip_img"
                  src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/daka_tip_1.png"
                  alt
                />
                <div class="calendar_tip_text">已打卡</div>
              </div>
              <div class="calendar_tip_item">
                <img
                  class="calendar_tip_img"
                  src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/daka_tip_2.png"
                  alt
                />
                <div class="calendar_tip_text">补卡</div>
              </div>
              <div class="calendar_tip_item">
                <img
                  class="calendar_tip_img"
                  src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/daka_tip_3.png"
                  alt
                />
                <div class="calendar_tip_text">已补卡</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 奖品区域 -->
        <div v-if="dakaInfo.dakaNumber === 0 || !userInfo.id" class="prize piece_pub">
          <div class="content_top">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_prize.png"
              alt
            />
          </div>

          <div class="pub_content">
            <!-- <div class="prize_list"> -->
            <div
              :class="['pub_content_item', item.number <= dakaInfo.continuousMaxDakaNumber ? 'pub_content_item_active' : '']"
              v-for="item in dakaInfo.dakaActivityPrizeDataList"
              :key="item.activityPrizeId"
            >
              <div class="pub_content_img_box">
                <img :src="item.prizePicture" alt />
              </div>
              <div
                v-if="item.number > dakaInfo.continuousMaxDakaNumber"
                class="pub_content_text"
              >待解锁</div>
              <div
                v-else
                class="pub_content_text"
                @click="onOpenReceive(item)"
              >{{ item.isReceive ? '已领取' : '领取' }}</div>
            </div>
          </div>
        </div>

        <!-- 活动规则item，三种状态通用 -->
        <div class="rule piece_pub">
          <div class="content_top">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_rule.png"
              alt
            />
          </div>

          <div class="pub_content">
            <div class="rc_item" v-for="item in dakaInfo.activityRule" :key="item">{{ item }}</div>
          </div>
        </div>
      </div>
      <CanvasImg :activityInfo="dakaInfo" ref="canvasImg" @onImgClose="onImgClose" />
      <!-- 分享补卡 -->
      <ShareModal
        :shareShow="shareShow"
        :dakaInfo="dakaInfo"
        :userInfo="userInfo"
        @onShareModalClose="onShareModalClose"
        @onBoostShare="onBoostShare"
        @onBukaSubmit="onBukaSubmit"
      />

      <!-- 打卡成功 -->
      <CheckSuccModal
        :checkSuccShow="checkSuccShow"
        :dakaInfo="dakaInfo"
        :userInfo="userInfo"
        @onCheckSuccClose="onCheckSuccClose"
      />

      <!-- 阶段奖品满足 -->
      <StepPrize
        :stepPrizeShow="stepPrizeShow"
        @onStepPrizeClose="onStepPrizeClose"
        :dakaInfo="dakaInfo"
        :stepCacheInfo="stepCacheInfo"
        :userInfo="userInfo"
      />
      <!-- 底部按钮 -->
      <div class="check_main_bottom">
        <div
          v-if="sign && dakaInfo.dakaNumber >= 0 && dakaInfo.dakaNumber < dakaInfo.maxDaysNum"
          @click="goDaka"
          class="bottom_btn"
        >
          {{
          dakaInfo.todayDone ? '今日已打卡' : '去打卡' }}
        </div>
        <div v-if="!sign" @click="onSign" class="bottom_btn">马上报名</div>
        <div v-if="dakaInfo.dakaNumber < dakaInfo.maxDaysNum" class="bottom_btm_empy"></div>
        <div v-if="dakaInfo.dakaNumber < dakaInfo.maxDaysNum" @click="share" class="bottom_btn">分享活动</div>
        <div
          v-if="dakaInfo.dakaNumber >= dakaInfo.maxDaysNum"
          @click="share"
          class="bottom_btn_big"
        >分享活动</div>
      </div>

      <!-- 领取奖品弹窗 -->
      <van-popup
        v-model="show"
        :close-on-click-overlay="true"
        :style="{ top: '142px', transform: 'translate3d(-50%, 0, 0)' }"
      >
        <div class="prize_modal_box">
          <div
            class="prize_modal_tip"
          >{{ returnInfo.isReceive && returnInfo.prizeType == 1 ? '领取成功' : `获得${returnInfo.prizeTypeName}` }}！</div>
          <img class="prize_modal_img" :src="returnInfo.prizePicture" alt />

          <!-- 有地址 & 未领取 -->
          <div
            class="prize_modal_address"
            v-if="returnInfo.isAddress && !returnInfo.isReceive"
          >请填写地址，我们会在活动结束后15日内寄出哦~</div>

          <!-- 有地址 & 已领取 -->
          <div
            v-if="returnInfo.isAddress && returnInfo.isReceive"
            class="prize_modal_address"
          >{{ address }}</div>

          <!-- 无地址 & 已领取 -->
          <div
            class="prize_modal_address"
            v-if="!returnInfo.isAddress && returnInfo.isReceive"
          >请关注个人账户</div>

          <!-- 有地址 & 未领取 -->
          <div
            v-if="returnInfo.isAddress && !returnInfo.isReceive"
            class="prize_modal_btn_address"
            @click="knowCloseReceive"
          >去填写</div>

          <!-- 已领取 -->
          <div class="prize_modal_btn_succ" v-if="returnInfo.isReceive">
            <div class="prize_modal_btn_close" @click="onCloseSucc(false)">知道了</div>
            <div class="prize_modal_btn_share" @click="onCloseSucc(true)">去分享</div>
          </div>
        </div>
      </van-popup>

      <!-- 领取奖品-选择规格弹窗 -->
      <van-popup
        v-model="prizeShow"
        closeable
        :close-on-click-overlay="false"
        :style="{ top: '142px', transform: 'translate3d(-50%, 0, 0)' }"
      >
        <!-- <div class=""></div> -->
        <div class="spec_box">
          <img
            class="spec_icon"
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/prize_spec_icon.png"
            alt
          />
          <div class="spec_content">
            <div class="tip_text">
              <span>该实物需要选择规格，请选择规格后</span>
              <span>再进行地址的填写~</span>
            </div>
            <div class="spec_list_box">
              <div class="spec_list_item" v-for="(item, index) in specJson" :key="index">
                <span>{{ item.name }}</span>
                <div class="spec_list">
                  <div
                    v-for="(v, key) in item.checkValues"
                    :key="key"
                    :style="specStyle(v, index) ? specStyle(v, index) : (checkSpec.find(item => item.check === v) ? { color: '#FFF', background: '#FD3665' } : {})"
                    @click="changeSpec(v, index)"
                  >{{ v }}</div>
                  <div
                    style="visibility: hidden;"
                    v-for="item in (3 - item.checkValues.length % 3)"
                    :key="item"
                  ></div>
                </div>
              </div>
            </div>
            <div class="spec_btn" @click="knowCloseReceive">去填写</div>
          </div>
        </div>
      </van-popup>

      <!-- 领取成功弹窗 废弃 -->
      <van-popup
        v-model="succShow"
        closeable
        :close-on-click-overlay="false"
        :style="{ top: '242px', transform: 'translate3d(-50%, 0, 0)' }"
      >
        <!-- <div class="vm_model">
          <div class="vm_tip">
            <div class="tip_title">领取成功</div>
            <div class="tip_text">
              <span v-if="dakaInfo.dakaActivityPrizeDataList.prizeType === 1">您领取的奖品为实物奖品</span>
              <span
                v-if="dakaInfo.dakaActivityPrizeDataList.prizeType === 2"
              >{{ dakaInfo.dakaActivityPrizeDataList.isAddress ? '您领取的奖品需要寄送' : '您领取的奖品为课程' }}</span>
              <span v-if="dakaInfo.dakaActivityPrizeDataList.prizeType === 3">您领取的奖品为优惠卷</span>
              <span>{{ dakaInfo.dakaActivityPrizeDataList.isAddress ? '我们将在活动结束后15日内发货' : '请关注个人账户哦' }}</span>
            </div>
            <div class="tip_btn" @click="closeSuccModel">知道了</div>
          </div>
        </div>-->
      </van-popup>
      <van-popup
        v-model="succShow"
        :close-on-click-overlay="true"
        :style="{ top: '142px', transform: 'translate3d(-50%, 0, 0)' }"
      >
        <div class="prize_modal_box">
          <div
            class="prize_modal_tip"
          >{{ returnInfo.isReceive && returnInfo.prizeType == 1 ? '领取成功' : `获得${returnInfo.prizeTypeName}` }}！</div>
          <img class="prize_modal_img" :src="returnInfo.prizePicture" alt />

          <div
            class="prize_modal_address"
          >{{ returnInfo.prizeType == 1 ? '我们将在活动结束后15日内发货' : '请关注个人账户哦' }}</div>

          <!-- 已领取 -->
          <div class="prize_modal_btn_succ" v-if="returnInfo.isReceive">
            <div class="prize_modal_btn_close" @click="onCloseSuccHas(false)">知道了</div>
            <div class="prize_modal_btn_share" @click="onCloseSuccHas(true)">去分享</div>
          </div>
        </div>
      </van-popup>
    </div>
    <div class="no_open" v-if="activeStatus === '1'">
      <img
        class="no_open_img"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/noopen.png"
        alt
      />
      <div class="no_open_text">活动暂未开始，看看其他活动吧~</div>
    </div>
    <div class="no_open" v-if="activeStatus === '2'">
      <img
        class="no_open_img"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/close.png"
        alt
      />
      <div class="no_open_text">活动已结束，看看其他活动吧~</div>
    </div>
    <div class="no_open" v-if="activeStatus === '3'">
      <img
        class="no_open_img"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/stop.png"
        alt
      />
      <div class="no_open_text">
        活动已关闭或奖品已全部领完，
        <br />看看其他活动吧~
      </div>
    </div>
  </div>
</template>

<script>
import CommonTimer from '@/components/commonComponents/CommonTimer.vue';
import moment, { max } from 'moment';
// eslint-disable-next-line import/no-cycle
import { getActiveDetail, givePrize, signUp, onBuka } from '@/api/check';
import { reqAddressList } from '@/api/personal/addressController';
import { whatEev } from '@/utils/tools';
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import { reqCheckProduct } from '@/api/pay';
import CanvasImg from './component/canvasImg.vue';
import ShareModal from './component/shareModal.vue';
import CheckSuccModal from './component/checkSuccess.vue';
import StepPrize from './component/stepPrize.vue';
import { miniSchemeUrl } from '@/utils/common';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

const urlObj = {
  0: '/pages/chooseLogin/chooseLogin',
  1: '/longSentences/list/list',
  2: '/zhangyuPractice/home/index',
  3: '/zhangyuPractice/politics/index',
  4: '/zhangyuPractice/formulaHandbook/index',
};

export default {
  components: {
    CommonTimer,
    CanvasImg,
    ShareModal,
    CheckSuccModal,
    StepPrize,
    swiper,
    swiperSlide,
  },
  // 根据userInfo.id 判断是否登录
  computed: {
    ...mapState(['userInfo']),
    specStyle() {
      return function(v, index) {
        const aaa = this.specHas(v, index);
        return aaa ? { background: 'rgb(245, 245, 245)', cursor: 'no-drop' } : false;
      };

      // return this.checkSpec.find(item => item.check === v) ? { color: '#FFF', background: '#FF7F41' } : {}
    },
    currTimeStr() {
      return `${this.currDate.slice(0, 4)}年${Number(this.currDate.slice(5, 7))}月`;
    },
  },
  watch: {
    prizeShow(newVal) {
      if (!newVal) {
        const specLs = JSON.parse(JSON.stringify(this.checkSpec));
        this.checkSpec = specLs.map(item => ({ type: item.type }));
      }
    },
  },
  data() {
    return {
      specJson: [], // 实物规格
      checkSpec: [], // 选择的实物规格
      endTime: '',
      show: false,
      prizeShow: false,
      succShow: false,
      checkSuccShow: false,
      stepPrizeShow: false,
      stepCacheInfo: {},
      activeStatus: '-1', // 0-进行中 1-未开始 2-已结束 3-已关闭
      dakaInfo: {
        activityRule: [],
        dakaActivityPrizeDataList: {},
      },
      addressId: '',
      address: '',
      calendarDateRange: [],
      calendarIndex: 0,
      currDate: '',
      minDate: '',
      maxDate: '',

      shareShow: false,

      returnInfo: {},

      sign: false, // 是否报名

      bukaTime: '',

      isLoading: false,

      canSuccModal: false,
    };
  },

  methods: {
    onCalenderSelect(e) {
      if (this.isLoading) {
        return;
      }
      if (this.toolActiveStatus()) {
        return;
      }
      const date = new Date(e);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      const time = `${year}-${month}-${day}`;
      console.log('eee999', time);
      this.bukaTime = time;
      const status = this.dakaInfo.userDakaDateMap[time];
      if (!status && this.isDateBeforeToday(time)) {
        this.shareShow = true;
      }
    },
    onShareModalClose() {
      this.shareShow = false;
    },
    // 分享助力
    onBoostShare() {
      this.shareShow = false;
    },

    onBukaSubmit() {
      if (this.isLoading) {
        return;
      }
      const submitInfo = {
        activityId: this.dakaInfo.activityId,
        dateStr: this.bukaTime,
        type: this.dakaInfo.dakaType,
      };
      this.isLoading = true;
      onBuka(submitInfo)
        .then(res => {
          this.getInfo();
          this.shareShow = false;
          this.$toast('补卡成功');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    onCheckSuccClose() {
      this.checkSuccShow = false;
    },

    onStepPrizeClose() {
      // 去领取
      // this.stepPrizeShow = false;
      this.onOpenReceive(this.stepCacheInfo);
    },
    onCloseSucc(isShare) {
      this.show = false;
      if (isShare) {
        if (!this.dakaInfo.dakaActivityPrizeDataList.find(item => !item.isReceive)) {
          this.canSuccModal = true;
        }
        this.share();
      } else {
        if (!this.dakaInfo.dakaActivityPrizeDataList.find(item => !item.isReceive)) {
          this.checkSuccShow = true;
        }
      }
    },
    onImgClose() {
      if (this.canSuccModal) {
        this.canSuccModal = false;
        this.checkSuccShow = true;
      }
    },
    onCloseSuccHas(isShare) {
      this.succShow = false;
      if (isShare) {
        this.share();
      }
    },
    openLogin() {
      // const path = `/check/${window.location.search}`;
      // const address = `${window.location.origin}/check`;

      if (this.$root.$data.isApp) {
        this.$sendToApp('login', {}, true);
      } else if (this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          // params.push('check=true');
          if (params) {
            const paramsMap = new Map();
            params.forEach(item => {
              const [key, value] = item.split('=');
              if (key) {
                paramsMap.set(key, value);
              }
            });
            const entries = paramsMap.entries();
            let query = '';
            const ExcludequeryArr = ['env', 'isPreview', 'activityId'];
            // eslint-disable-next-line no-restricted-syntax
            for (const [key, value] of entries) {
              if (ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
            }
            url = `${domain}?${query}`;
          }
        }
        const redirctUrl = encodeURIComponent(
          `/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`,
        );
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
      } else {
        const { path, query } = this.$route;
        this.$router.push({
          path: '/registrationLogin',
          query: { redirect: path, ...query },
        });
      }
    },
    onChangeYear(flag) {
      console.log('flag', flag);
      if (flag) {
        // 向后
        this.$refs.mySwiper.swiper.slideNext();
      } else {
        this.$refs.mySwiper.swiper.slidePrev();
        // const count = this.$refs.mySwiper.swiper.activeIndex;
        // 向前
        // if (count > 0) {
        // this.$refs.mySwiper.swiper.slideTo(count - 1);
        // }
      }
    },
    slideChange() {
      const count = this.$refs.mySwiper.swiper.activeIndex;
      this.calendarIndex = count;
      console.log(count);
      const item = this.calendarDateRange[count];
      this.currDate = item[0];
    },
    async onOpenReceive(info) {
      if (this.isPreview === 1) {
        return;
      }
      const { isReceive, number, isGetReceive, activityPrizeId, prizeType } = info;

      const prizeTypeMap = {
        1: '实物',
        2: '课程',
        3: '优惠券',
      };

      const returnInfo = await this.rawPrizeAddress(info);
      returnInfo.prizeTypeName = prizeTypeMap[prizeType];
      this.returnInfo = returnInfo;

      const { isAddress, specJson } = returnInfo;
      console.log('??????', returnInfo, prizeType);
      // this.specJson = specJson;

      if (isReceive) {
        this.succShow = true;
        return;
      }

      // 已经取 | 不可领取 | this.addressId 返回
      if (this.dakaInfo.continuousMaxDakaNumber < number || this.addressId) {
        return;
      }

      console.log('xinxia', info, returnInfo);

      // 如果有规格 则弹出规格弹窗
      if (specJson !== '[]' && specJson?.length > 0) {
        this.prizeShow = true;
        return;
      }
      // console.log(
      //   this.dakaInfo.dakaActivityPrizeDataList.prizeType,
      //   this.dakaInfo.dakaActivityPrizeDataList.isAddress,
      // );
      if (prizeType === 1 || (prizeType === 2 && isAddress)) {
        this.show = true;
      } else {
        const lqProzeInfo = {
          activityId: this.dakaInfo.activityId,
          activityPrizeId: activityPrizeId || '',
          terminalMark: this.$global.terminalMark,
          ip: sessionStorage.getItem('cityIp') || '',
        };
        givePrize(lqProzeInfo).then(pRes => {
          console.log(pRes);
          if (pRes.code === 0) {
            this.getInfo(true);
            this.show = true;
            this.returnInfo = {
              ...this.returnInfo,
              isReceive: true,
            };
          } else {
            this.$toast(pRes.msg || '领取失败');
          }
          this.stepPrizeShow = false;
        });
      }
      console.log('999');
    },
    knowCloseReceive() {
      if (this.isPreview === 1) {
        return;
      }
      sessionStorage.setItem('daka_return_prize_info', JSON.stringify(this.returnInfo));
      if (this.returnInfo.isAddress && !this.addressId) {
        // 去填写
        const isLq = this.checkSpec.every(spec => !!spec.check);
        if (!isLq && this.specJson && this.specJson.length > 0) {
          // this.$toast('请选择要领取的奖品规格')
          this.$toast({
            message: '请选择要领取的奖品规格',
            className: 'toastIndex',
          });
          return;
        }
        sessionStorage.setItem('checkSpec', JSON.stringify(this.checkSpec));
        // 去填写地址
        this.$router.push({
          path: '/personalCenter/address',
          query: {
            needBack: true,
            isActive: true,
          },
        });
      } else {
        this.show = false;
      }
    },
    openSuccModel() {
      this.succShow = true;
    },
    closeSuccModel() {
      this.succShow = false;
    },
    getInfo(isGive) {
      const { activityId: id, isPreview } = this.$route.query;
      if (sessionStorage.getItem('daka_return_prize_info')) {
        this.returnInfo = JSON.parse(sessionStorage.getItem('daka_return_prize_info'));
      }

      sessionStorage.removeItem('daka_return_prize_info');
      this.isLoading = true;
      getActiveDetail({ activityId: id, isPreview })
        .then(res => {
          const { data = {}, code } = res;
          if (code === 9001) {
            this.activeStatus = '1';
            return;
          }
          if (code === 9002) {
            this.activeStatus = '2';
            return;
          }
          if (code === 9408) {
            this.activeStatus = '3';
            return;
          }
          this.isLoading = false;
          this.activeStatus = '0';
          const {
            activityRule,
            dakaActivityPrizeDataList,
            startTime,
            activityPicture,
            activityName,
            endTime,
            dakaNumber: dakaNum,
            joinShowNumber = 0,
          } = data;

          this.minDate = data.startTime.slice(0, 10);
          this.maxDate = data.endTime.slice(0, 10);

          data.dakaActivityPrizeDataList = dakaActivityPrizeDataList?.sort((a, b) => {
            return a.number - b.number;
          });
          // if (isGive && !dakaActivityPrizeDataList.find(item => !item.isReceive)) {
          //   this.checkSuccShow = true;
          // }
          data.maxDaysNum =
            data.dakaActivityPrizeDataList[data.dakaActivityPrizeDataList.length - 1].number;
          data.activityRule = activityRule.split('\n') || [];
          data.dakaNumber = Number(dakaNum);
          data.joinShowNumber = Number(joinShowNumber);
          data.startTime = startTime.slice(0, 10).replace(/-/g, '.');
          data.endTime = endTime.slice(0, 10).replace(/-/g, '.');
          data.continuousDakaNumber = data.continuousDakaNumber || 0;
          data.continuousMaxDakaNumber = data.continuousMaxDakaNumber || 0;
          const userDakaDateMap = {};
          data.userDakaDateList?.forEach(item => {
            userDakaDateMap[item.userDakaDate.slice(0, 10)] = item.add ? 2 : 1; // 1打卡 2补卡
          });
          data.userDakaDateMap = userDakaDateMap;
          this.sign = data.sign;

          const range = this.splitDateRangeByMonth(startTime, endTime);
          this.calendarDateRange = range;
          console.log('range', range);
          let idx = 0;
          try {
            idx = this.$refs.mySwiper.swiper.activeIndex;
          } catch (error) {}
          this.currDate = range[idx][0];

          if (this.$root.miniprogram) {
            document.title = data.activityName;
          }

          this.endTime = moment(endTime).format('X');

          this.dakaInfo = data;
          this.insertRangeIndex(range, res.currentTime.slice(0, 10));
          // 假数据区域
          // this.userInfo.id = '99';
          // data.dakaNumber = 1
          // data.signNumber = 1
          // this.dakaNumber = 1
          // =====

          const { activityId, continuousMaxDakaNumber } = data;
          // 未领取过且打卡天数满足
          // if (!isReceive && dakaNumber === signNumber) {
          const addressId = sessionStorage.getItem('addressId');
          // 有addressId说明从选择地址页跳回的，可以走领取接口
          if (addressId) {
            console.log('daka_return_prize_info', this.returnInfo);
            const activityPrizeId = this.returnInfo?.activityPrizeId;
            // 从缓存中取到刚才选择的规格
            const cacheCheckSpec = sessionStorage.getItem('checkSpec') || JSON.stringify([]);
            this.checkSpec = JSON.parse(cacheCheckSpec);
            sessionStorage.removeItem('checkSpec');

            reqAddressList({ pageNum: 1, pageSize: 50 }).then(addRes => {
              const addressList = addRes?.data?.data || [];
              console.log(addRes);
              const addressInfo = addressList.find(item => item.id === Number(addressId)) || {};
              const { province, city, area, address } = addressInfo;
              const lqProzeInfo = {
                activityId,
                activityPrizeId: activityPrizeId,
                userAddressId: addressId,
                terminalMark: this.$global.terminalMark,
                ip: sessionStorage.getItem('cityIp') || '',
              };
              if (this.checkSpec.length > 0) {
                lqProzeInfo.specJson = JSON.stringify(this.checkSpec);
              }
              console.log('lqProzeInfo', lqProzeInfo);
              givePrize(lqProzeInfo)
                .then(pRes => {
                  console.log(pRes);
                  if (pRes.code === 0) {
                    this.address = `${province}${city}${area}${address}`;
                    this.addressId = addressId;
                    this.show = true;
                    sessionStorage.setItem('addressId', '');
                    this.returnInfo = {
                      ...this.returnInfo,
                      isReceive: true,
                    };
                    this.getInfo(true);
                  } else {
                    sessionStorage.setItem('addressId', '');
                    this.$toast(pRes.msg || '领取失败');
                  }
                  this.stepPrizeShow = false;
                })
                .finally(() => {
                  const specLs = JSON.parse(JSON.stringify(this.checkSpec));
                  this.checkSpec = specLs.map(item => ({ type: item.type }));
                });
            });
          } else {
            // 没地址，说明是初始化，要判断是否有符合条件但未领取的奖品
            let maxItem = {};
            data.dakaActivityPrizeDataList.forEach(item => {
              const { isReceive, number } = item;
              if (number <= continuousMaxDakaNumber) {
                maxItem = item;
              }
            });
            if (maxItem.activityPrizeId && !maxItem.isReceive) {
              if (!localStorage.getItem(`quickPrize_${activityId}_${maxItem.activityPrizeId}`)) {
                localStorage.setItem(`quickPrize_${activityId}_${maxItem.activityPrizeId}`, 'true');
                this.stepCacheInfo = maxItem;
                this.stepPrizeShow = true;
              }
            }
            // this.stepCacheInfo = data.dakaActivityPrizeDataList[0];
          }
          // }
          this.wxInit(activityPicture, activityName, activityId);
          console.log(JSON.stringify(data));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 处理奖品地址
    async rawPrizeAddress(info) {
      // info当前领取的奖品信息
      // 如果奖品类型是课程，则需要单独查是否需要地址

      const { specJson = '', prizeType, prizeSkuVOList = [], productId, productSkuId } = info || {};

      const returnInfo = { ...info };

      let specMap = {};
      let specDanMap = {};

      prizeSkuVOList?.forEach(vo => {
        const { skuName, canExchange } = vo;
        specMap[skuName] = Number(canExchange);

        const danSpecList = skuName?.split(',') || [];
        if (canExchange) {
          danSpecList.forEach(d => {
            specDanMap[d] = true;
          });
        }
      });
      console.log('guige init', specMap, specDanMap);
      this.specMap = specMap;
      this.specDanMap = specDanMap;

      this.specJson = JSON.parse(specJson || '[]');
      this.checkSpec = JSON.parse(specJson || '[]').map(item => {
        return {
          type: item.name,
        };
      });

      returnInfo.specMap = specMap;
      returnInfo.specDanMap = specDanMap;

      returnInfo.specJson = JSON.parse(specJson || '[]');
      returnInfo.checkSpec = JSON.parse(specJson || '[]').map(item => {
        return {
          type: item.name,
        };
      });

      if (prizeType === 2) {
        const subData = {
          products: [
            {
              productId,
              productSkuId,
              quantity: 1,
              type: 1,
            },
          ],
          userId: this.userInfo.id,
        };
        await reqCheckProduct(subData).then(cRes => {
          const { code: adCode, data: adData } = cRes;
          if (adCode === 0 && adData.needAddress) {
            // 需要地址
            returnInfo.isAddress = true;
          } else {
            // 不需要地址
            returnInfo.isAddress = false;
          }
        });
      }
      if (prizeType === 1) {
        returnInfo.isAddress = true;
      }
      return returnInfo;
    },

    onSign() {
      if (!this.userInfo.id) {
        this.openLogin();
        return;
      }
      if (this.toolActiveStatus()) {
        return;
      }
      signUp(this.dakaInfo.activityId).then(() => {
        this.sign = true;
      });
    },

    share() {
      if (this.isPreview === 1) {
        return;
      }
      this.$refs.canvasImg.createImg();
    },
    wxInit(activityPicture, activityName, activityId) {
      wx.ready(() => {
        // 需在用户可能点击分享按钮前就先调用
        wx.miniProgram.postMessage({
          data: {
            title: '就等你啦，参与打卡好课优惠免费领~',
            imageUrl: activityPicture,
            path: `${window.location.origin}${window.location.pathname}?activityId=${activityId}&isPreview=0`,
          },
        });
      });
    },
    goDaka() {
      if (!this.userInfo.id) {
        this.openLogin();
        return;
      }
      if (this.isPreview === 1) {
        return;
      }
      if (!this.sign) {
        return;
      }
      if (this.dakaInfo.todayDone) {
        return;
      }
      if (this.toolActiveStatus()) {
        return;
      }
      if (whatEev() === 'miniprogram') {
        wx.miniProgram.redirectTo({
          url: urlObj[this.dakaInfo.dakaType],
        });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: urlObj[this.dakaInfo.dakaType],
        });
      } else {
        this.getSchemeUrl();
      }
    },
    async getSchemeUrl() {
      const schemeLink = await miniSchemeUrl('wxdb89cfa2bb60f779', urlObj[this.dakaInfo.dakaType]);
      window.location.href = schemeLink;
    },

    // 奖品规格判断函数
    specHas(currSpec, index) {
      // console.log('currSpec', this.specDanMap[currSpec])

      if (!this.specDanMap[currSpec]) {
        return true;
      }

      // console.log('kjinbuqbfor???', this.specMap)

      const specMapList = Object.keys(this.specMap);

      let seach = false;

      for (let i = 0; i < specMapList.length; i++) {
        const spec = specMapList[i];

        let is = false;

        // console.log('for - i', i, spec)

        for (let j = 0; j < this.checkSpec.length; j++) {
          const { check } = this.checkSpec[j];
          if (check && index !== j) {
            if (spec.indexOf(check) === -1) {
              break;
            }
            console.log(
              'tiapshi:',
              `i:${i}, j:${j}, spec:${spec}, check:${check}, currSpec:${currSpec}`,
            );
          }
          // console.log('tiaoshi ', currSpec, i, j, spec, check, spec.indexOf(check))
          if (j === this.checkSpec.length - 1 && spec.indexOf(currSpec) !== -1) {
            is = true;
            seach = true;
          }
        }
        console.log(is, i, this.specMap[specMapList[i]], 'is');
        if (is && this.specMap[specMapList[i]] > 0) {
          return false;
        }
      }
      if (seach) {
        return true;
      }
      return false;
    },

    changeSpec(value, index) {
      const aaa = this.specHas(value, index);
      console.log('aaabian', aaa);
      if (aaa) {
        this.$toast({
          message: '奖品送光啦，请选择其他奖品吧',
          className: 'toastIndex',
        });
        return;
      }
      const ls = this.checkSpec;
      ls[index].check = value;
      console.log('ls', ls);
      this.checkSpec = ls;
      setTimeout(() => {
        this.specJson = [...this.specJson];
        console.log(this.checkSpec);
      }, 0);
    },
    splitDateRangeByMonth(startDate, endDate) {
      // const rawStartDate = startDate.
      // 格式化日期为 YYYY-MM-DD（使用本地时间）
      const format = date => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      };

      const start = new Date(startDate.replace(/\-/g, '/'));
      const end = new Date(endDate.replace(/\-/g, '/'));
      console.log('satrtapi', startDate, startDate.replace(/\-/g, '/'), start.getTime());

      // 验证和初始化
      if (isNaN(start.getTime()) || isNaN(end.getTime()) || start > end) {
        return [];
      }

      // 将时间部分归零
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);

      const result = [];
      let current = new Date(start);

      while (current <= end) {
        const year = current.getFullYear();
        const month = current.getMonth();

        // 获取当前月份最后一天
        const lastDayOfMonth = new Date(year, month + 1, 0);
        lastDayOfMonth.setHours(0, 0, 0, 0);

        // 确定区间结束日期
        const intervalEnd = lastDayOfMonth < end ? lastDayOfMonth : new Date(end);

        result.push([format(current), format(intervalEnd)]);

        // 移动到下个月第一天
        current = new Date(year, month + 1, 1);
        current.setHours(0, 0, 0, 0);
      }

      return result;
    },
    insertRangeIndex(range, currentTime) {
      if (!range || range.length === 0) {
        return;
      }
      const minTime = range[0][0];
      const maxTime = range[range.length - 1][1];
      if (this.diffTime(currentTime, minTime)) {
        return;
      }
      if (this.diffTime(maxTime, currentTime)) {
        this.setSwiperIndex(range.length - 1);
        return;
      }
      for (let i = 0; i < range.length; i++) {
        const [start, end] = range[i];
        if (this.diffTimeHas(start, currentTime) && this.diffTime(currentTime, end)) {
          this.setSwiperIndex(i);
          break;
        }
      }
    },
    setSwiperIndex(index) {
      setTimeout(() => {
        this.$refs.mySwiper.swiper.slideTo(index);
      }, 100);
    },
    isDateBeforeToday(date) {
      const input = new Date(date);
      const today = new Date();

      // 转换为YYYY-MM-DD格式字符串进行比较
      const inputDateStr = input.toISOString().split('T')[0];
      const todayDateStr = today.toISOString().split('T')[0];

      return inputDateStr < todayDateStr;
    },
    diffTime(date1, date2) {
      const input = new Date(date1);
      const today = new Date(date2);

      // 转换为YYYY-MM-DD格式字符串进行比较
      const inputDateStr = input.toISOString().split('T')[0];
      const todayDateStr = today.toISOString().split('T')[0];

      return inputDateStr < todayDateStr;
    },
    diffTimeHas(date1, date2) {
      const input = new Date(date1);
      const today = new Date(date2);

      // 转换为YYYY-MM-DD格式字符串进行比较
      const inputDateStr = input.toISOString().split('T')[0];
      const todayDateStr = today.toISOString().split('T')[0];

      return inputDateStr <= todayDateStr;
    },
    formatter(info) {
      try {
        // const dateString = info.date.replace(/^day\s+/, '');
        const date = new Date(info.date);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        const time = `${year}-${month}-${day}`;

        const today = new Date();

        const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
          2,
          '0',
        )}-${String(today.getDate()).padStart(2, '0')}`;

        // console.log(info);
        const timeMap = this.dakaInfo.userDakaDateMap;
        const timeList = this.dakaInfo.userDakaDateList;
        info.className = 'custom-day-none';
        if (timeMap[time]) {
          info.className = timeMap[time] == '1' ? 'custom-day-one' : 'custom-day-three';
        } else if (
          this.isDateBeforeToday(time) &&
          !this.diffTime(time, this.minDate) &&
          !this.diffTime(this.maxDate, time)
        ) {
          info.className = 'custom-day-two';
        }

        if (time == this.minDate) {
          info.className = info.className
            ? `${info.className} custom-day-start`
            : 'custom-day-start';
        }
        if (time == this.maxDate) {
          info.className = info.className ? `${info.className} custom-day-end` : 'custom-day-end';
        }
        if (todayStr == time) {
          info.className = info.className
            ? `${info.className} custom-day-today`
            : 'custom-day-today';
        }
        info.className = info.className ? `${info.className} ${time}` : `${time}`;
        // if()
      } catch (error) {
        // console.log(info.date, 'err');
      }

      return info;
    },
    toolActiveStatus(noMsg = false) {
      const map = {
        1: '活动暂未开始~',
        3: '活动已结束~',
        4: '活动已关闭~',
      };
      const msg = map[this.dakaInfo.activityStatus];
      if (msg) {
        if (!noMsg) {
          this.$toast(msg);
        }

        return true;
      }
      return false;
    },
  },

  mounted() {
    console.log('mountedzhixingl', sessionStorage.getItem('addressId'));
    const { isPreview = 0 } = this.$route.query;
    this.isPreview = Number(isPreview);
    this.getInfo();
  },
};
</script>

<style lang="scss">
.toastIndex {
  z-index: 10000001 !important;
}
</style>

<style scoped lang="scss">
.prize_modal_box {
  height: 864px;
  width: 634px;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/prize_modal_bkg.png')
    no-repeat;
  background-size: cover;
  overflow: hidden;

  .prize_modal_tip {
    width: 100%;
    height: 51px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 36px;
    color: #551919;
    line-height: 51px;
    margin: 228px auto 0;
    text-align: center;
  }

  .prize_modal_img {
    display: block;
    width: 254px;
    height: 254px;
    background: #ffeef1;
    border-radius: 29px;
    margin: 51px auto 0;
  }

  .prize_modal_address {
    width: 455px;
    height: 72px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 25px;
    color: #333333;
    line-height: 36px;
    margin: 29px auto 0;
    text-align: center;
  }

  .prize_modal_btn_address {
    width: 418px;
    height: 80px;
    background: linear-gradient(90deg, #ff2919 0%, #ff76a0 100%);
    border-radius: 40px;
    margin: 36px auto 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 29px;
    color: #ffffff;
    line-height: 80px;
    text-align: center;
  }

  .prize_modal_btn_succ {
    margin: 36px auto 0;

    height: 80px;
    display: flex;
    gap: 25px;
    justify-content: center;

    .prize_modal_btn_close {
      width: 246px;
      height: 80px;
      background: linear-gradient(90deg, #ff4819 0%, #ff7f41 100%);
      border-radius: 40px;
      font-family: PingFangSC, PingFang SC;

      font-weight: 500;
      font-size: 29px;
      color: #ffffff;
      line-height: 80px;
      text-align: center;
    }
    .prize_modal_btn_share {
      width: 246px;
      height: 80px;
      background: linear-gradient(90deg, #ff2919 0%, #ff76a0 100%);
      border-radius: 40px;
      font-weight: 500;
      font-size: 29px;
      color: #ffffff;
      line-height: 80px;
      text-align: center;
    }
  }
}

.spec_box {
  .spec_icon {
    display: block;
    height: 109px;
    width: 475px;
    margin: 0 auto 0;
  }

  .spec_content {
    width: 634px;
    // height: 694px;
    background: #ffffff;
    border-radius: 36px;
    margin: 29px auto 0;
    overflow: hidden;
    padding-bottom: 43px;

    .tip_text {
      width: 100%;
      height: 72px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 25px;
      color: #333333;
      line-height: 36px;
      font-style: normal;
      text-align: center;
      margin-top: 36px;
      span {
        display: block;
      }
    }
    .spec_list_box {
      padding: 0 27px 0;

      .spec_list_item {
        margin-top: 36px;
      }

      span {
        height: 36px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 25px;
        color: #333333;
        line-height: 36px;
        display: block;
      }

      .spec_list {
        display: flex;
        // gap: 9.5px;
        flex-wrap: wrap;
        justify-content: space-between;
        flex-wrap: wrap;

        div {
          flex-shrink: 0;
          width: 181px;
          height: 69px;

          background: #ffffff;
          border-radius: 18px;
          border: 2px solid #e8e8e8;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 22px;
          // color: #ffffff;
          color: #999999;
          line-height: 69px;
          text-align: center;
          margin-top: 14px;
        }
      }
    }
    .spec_btn {
      width: 418px;
      height: 80px;
      background: linear-gradient(90deg, #ff2919 0%, #ff76a0 100%);
      border-radius: 40px;
      margin: 53px auto 0;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 25px;
      color: #ffffff;
      line-height: 80px;
      text-align: center;
    }
  }
}

::v-deep {
  .van-calendar {
    background: #f4f7ff;
    width: 94.7%;
    margin: 0 auto;
  }
  .van-calendar__month-title {
    display: none;
  }

  .van-calendar__header {
    box-shadow: none;

    .van-calendar__weekdays {
      // padding: 18px 0px 0;
      padding-top: 18px;
      gap: 11px;

      .custom-day-one {
        background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_daka_1.png')
          no-repeat;
        background-size: cover;
      }

      .van-calendar__weekday {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        width: 36px;

        // line-height: 40px;
      }
    }
  }

  .van-calendar__body {
    margin-top: 10px;
    .van-calendar__days {
      // gap: 11px 11px;
      // justify-content: flex-start;
      // padding-left: 9px;
      overflow: hidden;
      width: auto;
    }
    .van-calendar__day {
      flex-shrink: 0;
      // height: 45px;
      // width: 36px;
      color: #333333 !important;
      transform: scale(0.8);
      font-size: 16px;
    }
    .van-calendar__selected-day {
      height: 45px;
      width: 36px;
      background: none;
      color: #333333 !important;
    }
  }

  .van-calendar__footer {
    display: none;
  }
}
::v-deep .custom-day-none {
  background: #ffffff;
}
::v-deep .custom-day-one {
  // 正常打卡
  position: relative;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_daka_1.png')
    no-repeat;
  background-size: cover;
}
::v-deep .custom-day-two {
  // 需要补卡
  position: relative;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_daka_2.png')
    no-repeat;
  background-size: cover;
}
::v-deep .custom-day-three {
  // 已补卡
  position: relative;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_daka_3.png')
    no-repeat;
  background-size: cover;
}

// 今天
::v-deep .custom-day-today {
  position: relative;
}
::v-deep .custom-day-today::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 27.5%;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_daka_today.png')
    no-repeat;
  background-size: cover;
}

// 开始
::v-deep .custom-day-start {
  position: relative;
}
::v-deep .custom-day-start::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 27.5%;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_daka_start.png')
    no-repeat;
  background-size: cover;
}

// 结束
::v-deep .custom-day-end {
  position: relative;
}
::v-deep .custom-day-end::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 27.5%;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_daka_end.png')
    no-repeat;
  background-size: cover;
}
.check_box {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  justify-items: baseline;
  width: 100%;
  padding-bottom: 174px;
  font-family: PingFangSC, PingFang SC, sans-serif;
  // background: #c8f3ff;
  // background: #D1F8FF;
  // background: rgb(194, 128, 255);

  .check_time {
    position: fixed;
    z-index: 3;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 750px;
    height: 51px;
    color: #fff;
    font-size: 25px;
    background: rgba(0, 0, 0, 0.3);
  }

  .check_main_image {
    width: 750px;
    height: 500px;

    img {
      width: 100%;
      height: 100%;
    }

    // background: rgb(214, 248, 254);
  }

  .check_main_content {
    flex: 1;
    width: 750px;
    height: 1399px;
    overflow: hidden;
    // background: #c8f3ff;
    padding-block: 29px;

    .calendar_box {
      margin: 29px auto 0;
      width: 678px;
      .calendar_title {
        width: 678px;
        height: 109px;
        background: linear-gradient(#fddf5f 0%, #fbf36e 100%);
        border-radius: 29px;
        border: 2px solid #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 7px;
        .img {
          display: block;
          height: 36px;
          width: 36px;
        }
        .img_hidden {
          visibility: hidden;
        }
        .year {
          height: 51px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 36px;
          color: #000000;
          line-height: 51px;
        }
      }

      .calendar_content {
        width: 678px;
        // min-height: 808px;
        background: #f4f7ff;
        border-radius: 29px;
        overflow: hidden;
        padding-bottom: 54px;

        .calendar_tip_box {
          width: 678px;
          height: 47px;
          padding: 0 74px 0;
          display: flex;
          margin-top: 60px;
          justify-content: space-between;
          .calendar_tip_item {
            display: flex;
            align-items: center;
            gap: 11px;
            .calendar_tip_img {
              height: 47px;
              width: 47px;
            }
            .calendar_tip_text {
              height: 47px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 25px;
              color: #666666;
              line-height: 47px;
            }
          }
        }
      }
    }

    .piece_pub {
      box-sizing: border-box;
      // height: 322px;
      width: 674px;
      margin: 29px auto 0;
      // padding: 18px 2px;
      // background: rgba(255, 255, 255, 0.4);
      // aspect-ratio: 11/5;
      // border: 2px solid #fff;
      border-radius: 0px 0px 29px 29px;
      overflow: hidden;

      .content_top {
        width: 674px;
        height: 111px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .pub_content {
        // width: 641px;
        width: 674px;
        overflow: hidden;
        background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
      }
    }

    .detail {
      .pub_content {
        padding: 14px 36px 38px;

        .dc_check {
          display: flex;
          // align-items: center;
          // height: 36px;
          margin-bottom: 47px;

          img {
            width: 63px;
            height: 33px;
            margin-top: 6px;
          }

          span {
            display: block;
            display: -webkit-box;
            margin-left: 16px;
            overflow: hidden;
            font-size: 33px;
            color: #333;
            font-weight: 500;
            line-height: 45px;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }

        .join_num {
          display: flex;
          height: 36px;
          margin-top: 22px;
          color: #666;
          font-weight: 400;
          font-size: 29px;
          line-height: 29px;
          align-items: center;
          .join_num_icon {
            display: block;
            height: 45px;
            width: 42px;
            margin-right: 14px;
          }

          span {
            color: #ff7f41;
          }
        }

        .active_time {
          height: 36px;
          margin-top: 22px;
          color: #666;
          font-weight: 400;
          font-size: 25px;
          line-height: 36px;
        }
      }
    }

    .prize {
      .pub_content {
        display: flex;
        // flex-direction: column;
        padding-bottom: 18px;
        padding: 18px 36px 36px;
        // justify-content: center;
        gap: 20px;
        overflow-x: auto;

        .pub_content_item {
          height: 239px;
          width: 188px;

          .pub_content_img_box {
            height: 188px;
            width: 188px;
            background: #f4f7ff;
            border-radius: 25px 25px 0px 0px;
            border: 2px solid #f4f7ff;
            overflow: hidden;

            img {
              display: block;
              height: 188px;
              width: 188px;
            }
          }

          .pub_content_text {
            height: 51px;
            line-height: 51px;
            background: #ffb7c8;
            border-radius: 0px 0px 22px 22px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 25px;
            color: #ffffff;
            text-align: center;
          }
        }

        .pub_content_item_active {
          .pub_content_img_box {
            border: 2px solid #fd3665;
          }
          .pub_content_text {
            background: #fd3665;
          }
        }
      }
    }

    .rule {
      .pub_content {
        padding: 9px 29px 14px;
        padding-top: 8px;
        padding-bottom: 16px;
      }

      .rc_item {
        margin-bottom: 22px;
        color: #333;
        font-weight: 400;
        // height: 40px;
        font-size: 28px;
        line-height: 40px;
        word-break: break-all;
      }
    }

    .scheduleing {
      .pub_content {
        width: 641px;
        padding-bottom: 36px;
      }

      .sc_progress_bar {
        display: flex;

        .sc_left {
          width: 507px;
          margin-top: 9px;
          margin-left: 36px;

          .sc_day {
            float: right;
            height: 25px;
            margin-bottom: 9px;
            padding-right: 8.5px;
            // width: 51px;
            padding-left: 8.5px;
            color: #333;
            font-weight: 400;
            font-size: 16px;
            font-family: PingFangSC, PingFang SC, sans-serif;
            line-height: 25px;
            background: #ffeee6;
            border-radius: 5px;

            span {
              color: #ff7f41;
            }
          }

          .sc_bar {
            float: left;
            // width: 507px;
            width: 100%;
            height: 18px;
            background: #efefef;
            border-radius: 12px;
          }

          .sc_bar_line {
            height: 18px;
            background: #ff7f41;
            // width: 50%;
            border-radius: 12px;
          }
        }

        img {
          display: block;
          width: 47px;
          height: 47px;
          margin-top: 24px;
          margin-left: 18px;
        }
      }

      .sc_text {
        width: 100%;
        height: 40px;
        margin-top: 34px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        line-height: 40px;
        text-align: center;
      }
    }

    .prizeing {
      .pub_content {
        // padding-left: 30px;
        padding-right: 0;
        padding-bottom: 49px;
      }

      .pcg_left_img {
        float: left;
        width: 163px;
        height: 163px;
        margin-top: 29px;
        margin-left: 36px;
        overflow: hidden;
        border: 2px solid #ffeaf1;
        border-radius: 25px;
      }

      .pcg_right {
        float: left;
        margin-top: 29px;
        margin-left: 29px;
        font-size: 25px;

        .pcg_title {
          height: 36px;
          color: #333;
          font-weight: 500;
          line-height: 36px;
        }

        .pcg_have {
          height: 36px;
          margin-top: 22px;
          font-weight: 400;
          line-height: 36px;

          span {
            color: #ff7f41;
            font-weight: 500;
          }

          .pcg_you {
            float: left;
          }

          .pcg_cha {
            float: left;
            width: 140px;
            height: 47px;
            margin-top: -6.5px;
            margin-left: 42px;
            font-weight: 400;
            line-height: 47px;
            text-align: center;
            background: #f5f5f5;
            border-radius: 26px;

            span {
              color: #ff7f41;
            }
          }

          .pcg_wc {
            color: #fff;
            background: #ff7f41;
          }

          .pcg_lq {
            color: #ff7f41;
            background: #fff;
            border: 2px solid #ff7f41;
            border-radius: 24px;
          }
        }
      }
    }
  }

  .check_main_bottom {
    // display: none;
    position: fixed;
    z-index: 3;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    height: 174px;
    width: 750px;
    padding: 18px 40px 42px;
    background: #fff;
    border-radius: 36px 36px 0 0;
    box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.1);
  }

  .bottom_btn {
    // flex: 1;
    flex-shrink: 0;
    width: 326px;
    height: 91px;
    color: #fff;
    font-weight: 500;
    font-size: 32px;
    font-family: PingFangSC, PingFang SC, sans-serif;
    line-height: 91px;
    text-align: center;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/active_btn.png')
      no-repeat;
    background-position: center center;
    background-size: 100%;
  }

  .bottom_btn_big {
    flex-shrink: 0;
    width: 670px;
    height: 91px;
    color: #fff;
    font-weight: 500;
    font-size: 32px;
    line-height: 91px;
    text-align: center;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/daka_ok.png')
      no-repeat;
    background-position: center center;
    background-size: 100%;
  }

  ::v-deep .van-popup {
    width: 84.54%;
    border-radius: 20px;

    .vm_model {
      position: relative;
      overflow: hidden;

      .vm_tip {
        width: 100%;
        overflow: hidden;
        font-family: PingFangSC, PingFang SC, sans-serif;
        background: #fff;
        border-radius: 20px;

        .tip_title {
          height: 25px;
          margin-top: 28px;
          color: #333;
          font-weight: 500;
          font-size: 18px;
          line-height: 25px;
          text-align: center;
        }

        .tip_text {
          height: 40px;
          margin-top: 20px;
          font-size: 14px;
          line-height: 20px;

          span {
            display: block;
            width: 100%;
            color: #333;
            font-weight: 400;
            text-align: center;
          }
        }

        .tip_address {
          margin-top: 12px;
          padding-right: 40px;
          // height: 20px;
          // max-width: 66%;
          padding-left: 40px;
          color: #ff1a3f;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          text-align: center;
        }

        .tip_btn {
          // width: 231px;
          width: 66%;
          height: 44px;
          margin: 24px auto;
          color: #fff;
          font-weight: 500;
          font-size: 14px;
          line-height: 44px;
          text-align: center;
          background-color: #ff7f41;
          border-radius: 22px;
        }

        .spec_box {
          padding: 0 27px 0;

          span {
            height: 25px;
            color: #333;
            font-weight: 500;
            font-size: 15px;
            line-height: 19px;
          }

          .spec_list {
            display: flex;
            // gap: 9.5px;
            flex-wrap: wrap;
            justify-content: space-between;

            div {
              width: 30%;
              height: 38px;
              margin-top: 10px;
              color: #999;
              font-weight: 400;
              font-size: 12px;
              line-height: 34px;
              text-align: center;
              border: 1px solid #e8e8e8;
            }
          }
        }
      }
    }
  }

  ::v-deep .van-popup {
    background-color: inherit;
  }
}

.no_open {
  width: 750px;
  height: 100vh;
  overflow: hidden;
  background: #f7f8fc;

  .no_open_img {
    display: block;
    width: 308px;
    height: 219px;
    margin: 428px auto 0;
  }

  .no_open_text {
    width: 750px;
    height: 40px;
    margin-top: 13px;
    color: #999;
    font-weight: 400;
    font-size: 25px;
    line-height: 40px;
    text-align: center;
  }
}
</style>
